module.exports = __webpack_public_path__ + "static/media/user_icon2.937d53bc.svg";